export default __webpack_public_path__ + "static/media/Bb2.87062489.mp3";